// extracted by mini-css-extract-plugin
module.exports = {"personContainer":"field-module--personContainer--3zgUO"};